export default {
  account_info: '賬戶信息',
  other_account: '交易賬戶申請',
  account_application: '期貨賬戶申請',
  records: '資金記錄',
  children_account: '銀行子賬號',
  setting: '設置',
  deposit: '存款記錄',
  depositTitle: '存款',
  withdrawal: '取款記錄',
  withdrawalTitle: '取款',
  transfer: '內部轉賬記錄',
  transferTitle: '內部轉賬',
  trade_product: '交易結構性產品申請',
  open_trades: '開放交易',
  close_trades: '關閉交易',
  download: '平台下載',
  'table-download': '文件下載',
  trade_recordes: '交易記錄',
  exchange: '換匯',
  quotes: '實時行情服務申請',
  bonds: '買賣債務申請',
  breadcrumb: {
    home: '首頁',
    my_account: '我的賬戶',
    'add-hkCard': '添加香港銀行卡',
    account_info: '賬戶信息',
    bonds: '買賣債務申請',
    other_account: '交易賬戶申請',
    account_application: '賬戶申請',
    trade_product: '交易結構性產品申請',
    records: '資金記錄',
    deposit: '存款記錄',
    depositTitle: '存款',
    withdrawal: '取款記錄',
    withdrawalTitle: '取款',
    transfer: '內部轉賬記錄',
    transferTitle: '內部轉賬',
    children_account: '銀行子賬號',
    setting: '設置',
    open_trades: '開放交易',
    close_trades: '關閉交易',
    online_bank_deposit: '網上銀行轉賬',
    atm_transfer_deposit: 'ATM 轉賬',
    bank_transfer_deposit: '銀行轉賬',
    cheque_deposit: '支票存款',
    fps_deposit: 'FPS轉數快',
    sub_account_deposit: '子賬戶存款',
    upload_deposit_reciept: '上傳存款收據',
    download: '平台下載',
    'table-download': '文件下載',
    trade_recordes: '交易記錄',
    exchange: '換匯',
    quotes: '實時行情服務申請',
    exchangeRecords: '換匯記錄'
  }
}
